import { useGetActiveBookingsMutation, useGetAllBookingsMutation, useGetFutureBookingsMutation, useGetPastBookingsMutation } from "@services/member/apartment/apartment.endpoints";
import DetailsBookings from "./DetailsBookings";

// « Toutes » reste l'onglet d'ouverture (habitude des opérateurs : la convention d'une
// réservation en cours ou passée doit être visible sans changer d'onglet), puis le même
// vocabulaire et le même ordre que l'écran « Réservations » : à venir, en cours, passées.
export const BookingsTabs = () => {
    return [
        {
            label: 'Toutes les réservations',
            component: <DetailsBookings key={'all'} mutationHook={useGetAllBookingsMutation}/>
        },
        {
            label: 'Réservations à venir',
            component: <DetailsBookings key={'future'} mutationHook={useGetFutureBookingsMutation} defaultDirection="asc" />
        },
        {
            label: 'Réservations en cours',
            component: <DetailsBookings key={'active'} mutationHook={useGetActiveBookingsMutation} defaultDirection="asc" />
        },
        {
            label: 'Réservations passées',
            component: <DetailsBookings key={'past'} mutationHook={useGetPastBookingsMutation}/>
        },
    ];
};
